import Logout from "./containers/jarvis/auth/logout";

import Dashboard from "./containers/jarvis/dashboard";

//JARVIS Quote Builder Pages
import QuoteBuilderSetup from "./containers/jarvis/quote-builder/quote-setup";
import QuoteBuilderItems from "./containers/jarvis/quote-builder/quote-items";
import QuoteBuilderRates from "./containers/jarvis/quote-builder/quote-rates";
import QuoteBuilderCustomiseProposal from "./containers/jarvis/quote-builder/customise-proposal";
import QuoteBuilderSendProposal from "./containers/jarvis/quote-builder/send-proposal";
import QuoteTemplateSetup from "./containers/jarvis/quote-builder/template-setup";
import QuoteBuilderPreviewTemplate from "./containers/jarvis/quote-builder/preview-template";
import QuoteBuilderCustomiseCAF from "./containers/jarvis/quote-builder/customise-caf";
import QuoteBuilderBillingContactCAF from "./containers/jarvis/quote-builder/billing-contact-caf";
import QuoteBuilderPrefillCAF from "./containers/jarvis/quote-builder/prefill-caf";
import QuoteBuilderSendForSigning from "./containers/jarvis/quote-builder/send-for-signing";
import QuoteBuilderCustomerAccepted from "./containers/jarvis/quote-builder/customer-accepted";

//JARVIS Quotes Pages
import MyQuotes from "./containers/jarvis/quotes/my-quotes";
import QuotesAll from "./containers/jarvis/quotes/quotes-all";

//JARVIS Admin Pages
import ProductList from "./containers/jarvis/admin/products/product-list";
import ProductForm from "./containers/jarvis/admin/products/product-form";
import CategoryList from "./containers/jarvis/admin/categories/category-list";
import AttributeList from "./containers/jarvis/admin/attributes/attribute-list";
import BundleList from "./containers/jarvis/admin/bundles/bundle-list";
import BundleForm from "./containers/jarvis/admin/bundles/bundle-form";
import QuoteTemplateList from "./containers/jarvis/admin/quote-templates/quote-template-list";
import ProposalTemplates from "./containers/jarvis/admin/proposal-templates";
import CAFSections from "./containers/jarvis/admin/caf-sections/caf-sections";
import CAFFormBuilder from "./containers/jarvis/admin/caf-form-builder/caf-form-builder";
import ManageTeams from "./containers/jarvis/admin/team-management/manage-teams";
import ManageUsers from "./containers/jarvis/admin/user-management/manage-users";
import EditUser from "./containers/jarvis/admin/user-management/edit-user";
import ManageAgents from "./containers/jarvis/admin/agent-management/manage-agents";
import ManagePartners from "./containers/jarvis/admin/partner-management/manage-partners";
import Reporting from "./containers/jarvis/reporting/reporting";
import AdminConfig from "./containers/jarvis/admin/settings/admin-settings";

import ResetPassword from "./containers/jarvis/user/reset-password";

const routes = [
  //Quote Builder Pages
  { path: "/new-quote", component: QuoteBuilderSetup, ispublic: true },
  { path: "/quote-setup", component: QuoteBuilderSetup, ispublic: true },
  { path: "/quote-setup/:quoteId", component: QuoteBuilderSetup, ispublic: true },
  { path: "/quote-items/:quoteId", component: QuoteBuilderItems, ispublic: true },
  { path: "/quote-rates/:quoteId", component: QuoteBuilderRates, ispublic: true },
  { path: "/customise-proposal/:quoteId", component: QuoteBuilderCustomiseProposal },
  { path: "/template-setup", component: QuoteTemplateSetup, forAdmin: true },
  { path: "/template-setup/:quoteId", component: QuoteTemplateSetup, forAdmin: true },
  { path: "/preview-template/:quoteId", component: QuoteBuilderPreviewTemplate, forAdmin: true },
  { path: "/send-proposal/:quoteId", component: QuoteBuilderSendProposal },
  { path: "/customise-caf/:quoteId", component: QuoteBuilderCustomiseCAF },
  { path: "/billing-contact-caf/:quoteId", component: QuoteBuilderBillingContactCAF },
  { path: "/prefill-caf/:quoteId", component: QuoteBuilderPrefillCAF },
  { path: "/send-for-signing/:quoteId", component: QuoteBuilderSendForSigning },
  { path: "/customer-accepted/:quoteId", component: QuoteBuilderCustomerAccepted },

  //Quotes Pages
  { path: "/my-quotes", component: MyQuotes },
  { path: "/quotes", component: QuotesAll },

  //Admin pages
  { path: "/admin/products", component: ProductList, forAdmin: true },
  { path: "/admin/product/create", component: ProductForm, forAdmin: true },
  { path: "/admin/product/edit/:pathArg", component: ProductForm, forAdmin: true },
  { path: "/admin/categories", component: CategoryList, forAdmin: true },
  { path: "/admin/attributes", component: AttributeList, forAdmin: true },
  { path: "/admin/bundles", component: BundleList, forAdmin: true },
  { path: "/admin/bundle/create", component: BundleForm, forAdmin: true },
  { path: "/admin/bundle/edit/:pathArg", component: BundleForm, forAdmin: true },
  { path: "/admin/quote-templates", component: QuoteTemplateList, forAdmin: true },
  { path: "/admin/proposal-templates", component: ProposalTemplates, forAdmin: true },
  { path: "/admin/caf-sections", component: CAFSections, forAdmin: true },
  { path: "/admin/caf-form-builder", component: CAFFormBuilder, forAdmin: true },
  { path: "/admin/manage-teams", component: ManageTeams, forAdmin: true },
  { path: "/admin/manage-users", component: ManageUsers, forAdmin: true },
  { path: "/admin/create-user", component: EditUser, forAdmin: true },
  { path: "/admin/edit-user/:id", component: EditUser, forAdmin: true },
  { path: "/admin/manage-agents", component: ManageAgents, forAdmin: true },
  { path: "/admin/manage-partners", component: ManagePartners, forAdmin: true },
  { path: "/admin/reporting", component: Reporting, forAdmin: true },
  { path: "/admin/admin-config", component: AdminConfig, forAdmin: true },

  { path: "/user/reset-password", component: ResetPassword },
  { path: "/logout", component: Logout, ispublic: true },
  { path: "/dashboard", component: Dashboard },
];

export default routes;
